import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  Suspense,
} from "react";
import { OGSidebar, TMDrawer, getParam } from "./TMShared.jsx";
import DATA from "./tmData.js";
import {
  addModule,
  addProjectDoc,
  addProjectTeamMember,
  addSegment,
  addSubModule,
  deleteModule,
  DeleteProject,
  deleteProjectDoc,
  deleteSegment,
  deleteSubModule,
  getProject,
  getProjectModule,
  getProjectTaskList,
  projectStatusUpdate,
  ProjectTaskList,
  removeProjectTeamMember,
} from "./Service/TaskService.js";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min.js";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding.js";
import AddProject from "./Add-Project.jsx";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys.js";
import { uploadDocFile } from "../Documents/DocumentService.js";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices.js";
import { MultiSelect } from "primereact/multiselect";
import { getEmployeeList } from "../EmployeeList/Service/employeeService.js";
import { TostMsg } from "../../../App.js";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader.jsx";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions.js";
import AddTask from "./Add-Task.jsx";

const TaskManagementProjectDetail = () => {
  // const projId = getParam("id"); // Default to first project
  // const activeModule = getParam('module') || projId;
  const [ptasks, setPtasks] = useState([]);
  const { projId } = useParams();
  const [filterQuery, setFilterQuery] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterModule, setFilterModule] = useState("");
  const [filterPriority, setFilterPriority] = useState("");
  const [loading, setLoading] = useState(true);
  const [projectDetails, setProjectDetails] = useState([]);
  const [segmentName, setSegmentName] = useState("");
  const [moduleName, setModuleName] = useState("");
  const [subModuleName, setSubModuleName] = useState("");
  const [segmentPopup, setSegmentPopup] = useState(false);
  const [modulePopup, setModulePopup] = useState(false);
  const [subModulePopup, setSubModulePopup] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [projectTaskList, setProjectTaskList] = useState([]);
  const [projectTaskSummary, setProjectTaskSummary] = useState([]);
  const [isArchConfirmOpen, setIsArchConfirmOpen] = useState(false);
  const [editProjectDetails, setEditProjectDetails] = useState({});
  const [isEditModalOpen, setIsModalOpen] = useState(false);
  const [isDeletedModal, setDeletedModal] = useState(false);
  const [docPathUrl, setDocPathUrl] = useState("");
  const [uploadFile, setUploadFile] = useState(false);
  const [isAllDeletedModal, setAllDeletedModal] = useState(false);
  const [isDeletedId, setDeletedId] = useState(0);
  const [deletedLabel, setDeletedLabel] = useState("");
  const [deleteSubModuleId, setSubModuleId] = useState(0);
  const [employeeList, setEmployeList] = useState([]);
  const [selectedMember, setSelectedMember] = useState(0);
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const history = useHistory();
  const [projectStatus, setProjectStatus] = useState([]);
  let userPermissions = getRawPermissionsArray();
  const [createProject, setCreateProject] = useState(false);
  const [isModalOpen, setAddModalOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const getPlainText = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html || "";
    return div.textContent || div.innerText || "";
  };

  const plainText = getPlainText(projectDetails?.Desc);
  const CHAR_LIMIT = 120;
  const isLong = plainText.length > CHAR_LIMIT;


  useEffect(() => {
    getProjectDetails();
    GetMasterSystemAlertList();
    permissionList();
  }, [projId]);

  useEffect(() => {
    getMasterModuleList();
    getMasterTaskPriorityCategory();
    getMasterTaskStatusCategory();
    getProjectStatusCategory();
  }, [projectDetails]);

  // if (!proj) {
  //   return <div>Loading project...</div>;
  // }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  const permissionList = () => {
    if (userPermissions) {
      userPermissions.forEach((UserPermission) => {
        if (UserPermission?.PermissionName === "Project.Create") {
          setCreateProject(true);
        }
      });
    }
  };

  async function fetchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeList(employeesList.Data);
      setLoading(false);
    } catch (error) {
      toster.current.error(error.employeesList.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  }

  async function getProjectDetails() {
    setLoading(true);

    let body = {
      Id: 0,
      guid: projId,
    };

    try {
      let res = await getProject(body);
      const response = res?.Data[0] || [];

      setProjectDetails(response);
      getProjectsTaskList(response?.Id);
    } catch (error) {
      toster.current.error(error.res.Data?.Message || "somthing went wrong");

    } finally {
      setLoading(false);
    }
  }

  async function getProjectStatusCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "ProjectStatus",
    };
    // setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setProjectStatus(data?.Data || []);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  useEffect(() => {
    getProjectsTaskList(projectDetails?.Id);
  }, [filterStatus, filterModule, filterPriority, filterQuery, projectDetails?.Id]);

  async function getProjectsTaskList(projectId) {
    if (!projectId) return;
    
    const params = {
      RaisedByEmpId: "",
      AssignedToId: "",
      TaskId: 0,
      StatusId: filterStatus ? filterStatus?.toString() : "",
      ModuleId: filterModule ? filterModule?.toString() : "",
      SubModuleId: "",
      PriorityId: filterPriority ? filterPriority?.toString() : "",
      SeverityId: "",
      Search: filterQuery ? filterQuery : "",
      FilterStartDate: "",
      FilterEndDate: "",
      PageNumber: 1,
      PageSize: 10,
      IsDeleted: 0,
      SprintId: 0,
      TaskNumber: "",
      TaskGUID: "",
      ProjectId: projectId?.toString(),
      ParentTaskId: 0,
      TaskTypeId: "",
      SegmentId: "",
      SortBy: "",
      SortOrder: "ASC",
    };
    try {
      const response = await getProjectTaskList(params);
      setProjectTaskList(response?.Data?.OrgEmpTasks);
      setProjectTaskSummary(response?.Data?.TaskStatusCounts);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(error.response.Data?.Message || "somthing went wrong");

    }
  }

  async function AddModule() {
    setModuleError(false);
    let params = {
      Id: 0,
      ProjectId: projectDetails?.Id,
      Name: moduleName,
    };
    setLoading(true);
    try {
      if (moduleName) {
        const response = await addModule(params);
        setLoading(false);
        if (response?.StatusCode === 2000) {
          setModuleName("");
          setModulePopup(false);
          getProjectDetails();
          GetMasterSystemAlertList("Project_AddModule", 0);
        } else {
          toster.current.error(response.Data?.Message || "Something went wrong. Please try again.");
        }
      } else {
        setLoading(false);
        setModuleError(true);
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  }

  async function AddSubModule() {
    setSUbModuleError(false);
    let params = {
      Id: 0,
      ModuleId: selectedModuleId,
      ProjectId: projectDetails?.Id,
      Name: subModuleName,
    };
    setLoading(true);
    try {
      if (subModuleName) {
        const response = await addSubModule(params);
        setLoading(false);
        if (response?.StatusCode === 2000) {
          setSubModuleName("");
          setSubModulePopup(false);
          getProjectDetails();
          GetMasterSystemAlertList("Project_AddSubModule", 0);
        } else {
          toster.current.error(response.Data?.Message || "Something went wrong. Please try again.");
        }
      } else {
        setLoading(false);
        setSUbModuleError(true);
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  }
  const [segmentError, setSegmentError] = useState(false);
  const [moduleError, setModuleError] = useState(false);
  const [subModuleError, setSUbModuleError] = useState(false);
  const [selectedModuleId, setSelectedModuleId] = useState(0);
  async function AddSegment() {
    setSegmentError(false);
    let params = {
      Id: 0,
      ProjectId: projectDetails?.Id,
      Name: segmentName,
    };
    setLoading(true);
    try {
      if (segmentName) {
        const response = await addSegment(params);
        setLoading(false);
        if (response?.StatusCode === 2000) {
          setSegmentName("");
          setSegmentPopup(false);
          getProjectDetails();
          GetMasterSystemAlertList("Project_AddSegment", 0);
        } else {
          toster.current.error(response.Data?.Message || "Something went wrong. Please try again.");
        }
      } else {
        setLoading(false);
        setSegmentError(true);
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  }

  async function DeleteSegment(segmentId) {
    let params = {
      ProjectId: projectDetails?.Id,

      SegmentId: isDeletedId,
    };
    setLoading(true);
    try {
      if (isDeletedId) {
        const response = await deleteSegment(params);
        setLoading(false);
        if (response?.StatusCode === 2000) {
          setDeletedId(0);
          setAllDeletedModal(false);
          setDeletedLabel("");
          getProjectDetails();
          GetMasterSystemAlertList("Project_DeleteSegment", 0);
        } else {
          toster.current.error(response.Data?.Message || "Something went wrong. Please try again.");
        }
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  }

  async function DeleteModule(moduleId) {
    let params = {
      ProjectId: projectDetails?.Id,

      ModuleId: isDeletedId,
    };
    setLoading(true);
    try {
      if (isDeletedId) {
        const response = await deleteModule(params);
        setLoading(false);
        if (response?.StatusCode === 2000) {
          setDeletedId(0);
          setAllDeletedModal(false);
          setDeletedLabel("");
          getProjectDetails();
          GetMasterSystemAlertList("Project_DeleteModule", 0);
        } else {
          toster.current.error(response.Data?.Message || "Something went wrong. Please try again.");
        }
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  }

  async function DeleteSubModule() {
    let params = {
      ProjectId: projectDetails?.Id,
      SubModuleId: isDeletedId,
      ModuleId: deleteSubModuleId,
    };
    setLoading(true);
    try {
      if (isDeletedId && deleteSubModuleId) {
        const response = await deleteSubModule(params);
        setLoading(false);
        if (response?.StatusCode === 2000) {
          setDeletedId(0);
          setSubModuleId(0);
          setAllDeletedModal(false);
          setDeletedLabel("");
          getProjectDetails();
          GetMasterSystemAlertList("Project_DeleteSubModule", 0);
        } else {
          toster.current.error(response.Data?.Message || "Something went wrong. Please try again.");
        }
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  }

  async function DeleteProjectDoc() {
    let params = {
      ProjectId: projectDetails?.Id,
      DocId: isDeletedId,
      DeletedById: userDetails?.Id,
    };
    setLoading(true);
    try {
      if (isDeletedId) {
        const response = await deleteProjectDoc(params);
        setLoading(false);
        if (response?.StatusCode === 2000) {
          setDeletedId(0);
          setAllDeletedModal(false);
          setDeletedLabel("");
          getProjectDetails();
          GetMasterSystemAlertList("Project_FileDelete", 0);
        } else {
          toster.current.error(response.Data?.Message || "Something went wrong. Please try again.");
        }
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  }

  async function AddTeamMember() {
    const params = {
      ProjectId: projectDetails?.Id,
      EmpIds: selectedMember,
    };
    setLoading(true);
    try {
      const response = await addProjectTeamMember(params);
      setLoading(false);
      if (response?.StatusCode === 2000) {
        setSelectedMember("");
        getProjectDetails();
        GetMasterSystemAlertList("Project_AddTeamMember", 0);
      } else {
        toster.current.error(response.Data?.Message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  }

  async function RemoveTeamMember() {
    const params = {
      ProjectId: projectDetails?.Id,
      EmpId: isDeletedId,
    };
    setLoading(true);
    try {
      if (isDeletedId) {
        const response = await removeProjectTeamMember(params);
        setLoading(false);
        if (response?.StatusCode === 2000) {
          setDeletedId(0);
          setDeletedLabel("");
          setAllDeletedModal(false);
          getProjectDetails();
          GetMasterSystemAlertList("Project_RemoveTeamMember", 0);
        } else {
          toster.current.error(response.Data?.Message || "Something went wrong. Please try again.");
        }
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  }

  const deletedAll = () => {
    if (deletedLabel === "module") {
      DeleteModule();
    }
    if (deletedLabel === "sub-module") {
      DeleteSubModule();
    }
    if (deletedLabel === "segment") {
      DeleteSegment();
    }

    if (deletedLabel === "doc") {
      DeleteProjectDoc();
    }

    if (deletedLabel === "member") {
      RemoveTeamMember();
    }
  };

  // Helper functions (kept similar to original)
  const sBadge = (status) => {
    const map = {
      Active: "bg-active",
      Archived: "bg-archived",
      Open: "bg-open",
      "In Progress": "bg-inprog",
      Review: "bg-review",
      Resolved: "bg-resolved",
      Closed: "bg-closed",
    };
    return map[status] || "bg-medium";
  };

  const pBadge = (priority) => {
    const map = {
      Critical: "bg-critical",
      High: "bg-high",
      Medium: "bg-medium",
      Low: "bg-low",
    };
    return map[priority] || "bg-medium";
  };

  const tBadge = (type) => {
    return type === "Bug" ? "bg-bug" : "bg-enhancement";
  };

  const segBadge = (segment) => {
    const map = {
      Web: "bg-web",
      iOS: "bg-ios",
      Android: "bg-android",
      API: "bg-api",
    };
    return map[segment] || "bg-medium";
  };

  const avHtml = (name, size = 24) => {
    const initial = name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
    return (
      <div
        style={{
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          background: "#671cc9",
          color: "#fff",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "700",
          fontSize: "9.38px",
          flexShrink: " 0",
        }}
      >
        {initial}
      </div>
    );
  };

  const fmtDate = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  };

  // Render functions
  const renderHeader = () => {
    const done = ptasks?.filter(
      (t) => t?.status === "Closed" || t?.status === "Resolved",
    ).length;
    const pct = ptasks.length ? Math.round((done / ptasks?.length) * 100) : 0;
    const rawDesc = (projectDetails?.Desc || "No description.").replace(
      /<[^>]+>/g,
      "",
    );
    const hasMore = rawDesc.length > 220;
    const shortTxt = hasMore ? rawDesc.substring(0, 220) + "…" : rawDesc;

    return (
      <div className="card mb14" style={{ padding: "18px", display: "none" }}>
        <div className="flex" style={{ alignItems: "flex-start", gap: "14px" }}>
          <div style={{ flex: 1 }}>
            <div className="actions-status-inline">
              <span>
                <code>
                  {projectDetails?.ProjectCode}
                </code>
              </span>
              <span
                className={`badge ${sBadge(projectDetails?.ProjectStatus)}`}
              >
                {projectDetails?.ProjectStatus}
              </span>
              {projectDetails?.ProjectType && (
                <span
                  style={{
                    fontSize: "11px",
                    background: "#f1f3f5",
                    padding: "2px 9px",
                    borderRadius: "100px",
                    color: "var(--mid)",
                  }}
                >
                  {projectDetails?.ProjectType}
                </span>
              )}

            </div>
            <h2 className="task-detail-title">
              {projectDetails?.Name}
            </h2>

            <div className="ql-editor project-task-description">
              <div
                dangerouslySetInnerHTML={{
                  __html: projectDetails?.Desc || "<p>No description</p>",
                }}
              />
            </div>

            <div
              className="flex gap14 text-muted"
              style={{ fontSize: "12px", gap: "14px" }}
            >
              <span>
                <i
                  className="fa-regular fa-calendar"
                  style={{ marginRight: "3px" }}
                ></i>
                {fmtDate(projectDetails?.StartDate)} →{" "}
                {fmtDate(projectDetails?.EndDate)}
              </span>
              <span>
                <i
                  className="fa-solid fa-users"
                  style={{ marginRight: "3px" }}
                ></i>
                {projectDetails?.Members}{" "}
                {projectDetails?.Members > 1 ? "members" : "member"}
              </span>
              <span onClick={() => {
                document
                  .getElementById("task-list-section")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
                style={{ cursor: "pointer" }}
              >
                <i
                  className="fa-solid fa-list-check"
                  style={{ marginRight: "3px" }}
                ></i>
                {projectDetails?.TaskCount}{" "}
                {projectDetails?.TaskCount > 1 ? "tasks" : "task"}
              </span>
            </div>
          </div>

          <div style={{ textAlign: "right", minWidth: "160px" }}>
            <div
              style={{
                fontSize: "36px",
                fontWeight: "800",
                color: "var(--brand)",
                lineHeight: "1",
              }}
            >
              {projectDetails?.ProgressPercentage}%
            </div>
            <div
              style={{
                fontSize: "11.5px",
                color: "var(--muted)",
                marginBottom: "6px",
              }}
            >
              {projectDetails?.CompletedTaskCount} / {projectDetails?.TaskCount}{" "}
              done
            </div>
            <div className="pbar" style={{ height: "6px" }}>
              <div
                className="pfill"
                style={{ width: `${projectDetails?.ProgressPercentage}%` }}
              ></div>
            </div>
            <div
              className="flex"
              style={{
                flexWrap: "wrap",
                gap: "3px",
                marginTop: "8px",
                justifyContent: "flex-end",
              }}
            >
              {projectDetails?.members?.slice(0, 6).map((m, i) => (
                <React.Fragment key={i}>{avHtml(m, 26)}</React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderSummary = () => {
    return (

      <div className="sstrip">
        <p className="upcoming-title">Tasks Summary
          <div style={{ textAlign: "right", width: "237px", display: "flex", alignItems: "center", gap: "9px" }}>

            <div className="pbar" style={{ height: "6px" }}>
              <div className="pfill" style={{ width: `${projectDetails?.ProgressPercentage}%` }}></div>
            </div>
            <div
              className="flex"
              style={{
                flexWrap: "wrap",
                gap: "3px",
                marginTop: "8px",
                justifyContent: "flex-end",
              }}
            >
              {projectDetails?.members?.slice(0, 6).map((m, i) => (
                <React.Fragment key={i}>{avHtml(m, 26)}</React.Fragment>
              ))}
            </div>
            <div
              style={{
                fontSize: "20px",
                fontWeight: "800",
                color: "var(--brand)",
                lineHeight: "1",
              }}
            >
              {projectDetails?.ProgressPercentage}%
            </div>
            <div
              style={{
                fontSize: "11.5px",
                color: "var(--muted)"
              }}
            >
              {projectDetails?.CompletedTaskCount} / {projectDetails?.TaskCount} done
            </div>
          </div>
        </p>
        {projectTaskSummary?.map((k, i) => (
          <div key={i} className={`sc ${k.c}`}>
            <div className="sc-lab">{k.Status}</div>
            <div className="sc-val">{k.TaskCount}</div>
          </div>
        ))}
      </div>
    );
  };

  const [selectedStatus, setSelectedStatus] = useState("");
  const handleStatusChange = async (event) => {
    setSelectedStatus(event);

    const params = {
      ProjectId: projectDetails?.Id,
      ProjectStatusId: event,
    };
    setLoading(true);
    try {
      const response = await projectStatusUpdate(params);
      if (response?.StatusCode === 2000) {
        GetMasterSystemAlertList("Status_Update", 0);
        await getProjectDetails();
      }
      setLoading(false);
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setLoading(false);
    }
  };

  const renderClientSection = () => {
    const c = projectDetails?.ClientName;
    if (!c) {
      return (
        <div style={{ fontSize: "12.5px", color: "var(--muted)" }}>
          No client assigned.
        </div>
      );
    }
    return (
      <>
        <div
          style={{
            fontSize: "14px",
            fontWeight: "700",
            color: "#e82c20",
            marginBottom: "0px",
          }}
        >
          {c}
        </div>
      </>
    );
  };

  const renderTeamSection = () => {
    return projectDetails?.ProjectMemberList?.map((m, i) => {
      // const isMgr = m === projectDetails?.manager;
      return (
        <div key={m?.Id} className="team-row" title={m?.EmployeeName}>
          <Link to={`/Profile/${m?.EmployeeGUID}`}>
            <LazyImage alt={m.EmployeeName} src={m.ProfileImage} />
            {/* <LazyImage alt={m.EmployeeName} src={m.ProfileImage} /> */}
            {/* {avHtml(m?.EmployeeName, 22)} */}
          </Link>
        </div>
      );
    });
  };

  const renderFilesSection = () => {
    const files = projectDetails?.ProjectDocList || [];
    if (!files.length) {
      return (
        <div
          style={{
            textAlign: "center",
            padding: "16px",
            color: "var(--muted)",
            fontSize: "12.5px",
          }}
        >
          <i
            className="fa-solid fa-paperclip"
            style={{
              fontSize: "22px",
              display: "block",
              marginBottom: "6px",
              opacity: "0.2",
            }}
          ></i>
          No files yet
        </div>
      );
    }
    return files.map((f, i) => {
      const normalized = f?.DocPath?.replace(/\\/g, "/");
      const fileWithExt = //normalized.substring(normalized.lastIndexOf("/") + 1);
        normalized.split("/").pop();
      const ext = fileWithExt.split(".").pop();
      const fileName = fileWithExt.substring(0, fileWithExt.lastIndexOf("."));
      const icon =
        ext === "pdf"
          ? "fa-file-pdf"
          : ext === "xlsx" || ext === "xls"
            ? "fa-file-excel"
            : ext === "docx" || ext === "doc"
              ? "fa-file-word"
              : "fa-file";
      const icolor =
        ext === "pdf"
          ? "#ef4444"
          : ext === "xlsx" || ext === "xls"
            ? "#22c55e"
            : ext === "docx" || ext === "doc"
              ? "#3b82f6"
              : "#8b5cf6";
      const ibg =
        ext === "pdf"
          ? "#fee2e2"
          : ext === "xlsx" || ext === "xls"
            ? "#dcfce7"
            : ext === "docx" || ext === "doc"
              ? "#dbeafe"
              : "#ede9fe";

      return (
        <div key={i} className="file-card" style={{ padding: "8px 14px" }}>
          <div className="file-ico-pd" style={{ background: ibg }}>
            <i className={`fa-solid ${icon}`} style={{ color: icolor }}></i>
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                fontWeight: "600",
                fontSize: "12.5px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {fileWithExt}
            </div>
            {/* <div style={{ fontSize: "11px", color: "var(--muted)" }}>
              {f.size} · {f.by}
            </div> */}
          </div>
          <button
            className="btn btn-ghost btn-icon"
            title="Download"
            onClick={() =>
              window.open(f?.DocPath, "_blank", "noopener,noreferrer")
            }
          >
            <i className="fa-solid fa-download"></i>
          </button>
          {createProject && (
            <button
              className="btn btn-ghost btn-icon btn-sm text-danger"
              onClick={() => {
                setAllDeletedModal(true);
                setDeletedId(f?.Id);
                setDeletedLabel("doc");
              }}
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          )}
        </div>
      );
    });
  };

  const askArchive = (id) => {
    setIsArchConfirmOpen(true);
  };

  async function archiveProject() {
    const params = {
      ProjectId: projectDetails?.Id,
      ProjectStatusId: 106,
    };
    try {
      const response = await projectStatusUpdate(params);
      if (response?.StatusCode === 2000) {
        setIsArchConfirmOpen(false);
        GetMasterSystemAlertList("Project_Archive", 0);
        // toster.current.success("Project archived successfully.")
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    }
  }

  const editProject = () => {
    setEditProjectDetails(projectDetails);
    setIsModalOpen(true);
  };

  const onClosePopup = (e) => {
    setIsModalOpen(false);
    setEditProjectDetails({});
    getProjectDetails();
  };

  const askDeleteConfirm = () => {
    setDeletedModal(true);
  };

  async function deleteProject() {
    const params = {
      Id: projectDetails?.Id,
    };

    try {
      const response = await DeleteProject(params);
      if (response?.StatusCode === 2000) {
        GetMasterSystemAlertList("Project_Delete", 0);
      }
      setDeletedModal(false);
      getProjectDetails();
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
      setDeletedModal(false);
    }
  }

  const handleFileChangeDoc = (event, type) => {
    const files = event.target.files;

    const fileArray = Array.from(files);

    if (fileArray.length > 0) {
      uploadFolderDocFile(fileArray);
    }
  };

  async function uploadFolderDocFile(file) {
    // setIsloading(true);

    if (file) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.Project,
        RefId: 0,
      };

      try {
        const response = await uploadDocFile(params, formData);
        const data = await response;
        const docPathURL = data?.Data;

        setDocPathUrl(docPathURL[0]);

        // setIsloading(false);
      } catch (error) {
        // setIsloading(false);
        toster.current.error(error.response.Data?.Message || "somthing went wrong");
      } finally {
      }
    } else {
      // setIsloading(false);
      // toster.current.warn("No file selected");
    }
  }

  async function projectDocAdd() {
    const params = {
      ProjectId: projectDetails?.Id,
      DocPath: docPathUrl,
    };

    try {
      const response = await addProjectDoc(params);
      if (response?.StatusCode === 2000) {
        setUploadFile(false);
        getProjectDetails();
        GetMasterSystemAlertList("Project_FileUpload", 0);
      } else {
        toster.current.error(response.Data?.Message || "somthing went wrong");
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    }
  }

  const [masterModuleList, setMasterModuleList] = useState([]);
  const [taskPriorityList, setTaskPriorityType] = useState([]);
  const [taskStatusType, setTaskStatusType] = useState([]);
  const [editMemberDrawer, setEditMemberDrawer] = useState(false);
  async function getMasterModuleList() {
    const params = {
      ProjectId: projectDetails?.Id,
    };

    try {
      const res = await getProjectModule(params);
      setMasterModuleList(res?.Data);
    } catch (error) {
      toster.current.error(error.res.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskPriorityCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "TaskPriority",
    };
    // setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setTaskPriorityType(data?.Data);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskStatusCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "TaskStatus",
    };
    // setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setTaskStatusType(data?.Data);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  // Filter tasks
  const filteredTasks = ptasks.filter((t) => {
    const q = filterQuery.toLowerCase();
    const matchesSearch =
      !q ||
      t.title.toLowerCase().includes(q) ||
      t.taskNo.toLowerCase().includes(q);
    const matchesStatus = !filterStatus || t.status === filterStatus;
    const matchesModule = !filterModule || t.module === filterModule;
    const matchesPriority = !filterPriority || t.priority === filterPriority;
    return matchesSearch && matchesStatus && matchesModule && matchesPriority;
  });

  const NavigateTaskDetail = (task) => {
    history.push(`/Project/Task/Detail/${task?.GUID}`);
  };





  return (
    <div className="">
      <div className="task-top-pane">
        <i class="fa fa-thumb-tack i-ico" aria-hidden="true"></i>
        <div className="task-top-pane-title">
          <h4>Welcome to OrgGenie</h4>
          <p>Manage your tasks, projects, and workspaces in one place.</p>
        </div>
      </div>
      <div className="tm-main-area">
        <div className="card">
          <div className="client-head">
            <div className="top">

              <div className="actions-status-inline">
                <span className="code">
                  <code>
                    {projectDetails?.ProjectCode}
                  </code>
                </span>
                <span
                  className={`badge ${sBadge(projectDetails?.ProjectStatus)}`}
                >
                  {projectDetails?.ProjectStatus}
                </span>
                {projectDetails?.ProjectType && (
                  <span
                    style={{
                      fontSize: "11px",
                      background: "#f1f3f5",
                      padding: "2px 9px",
                      borderRadius: "100px",
                      color: "var(--mid)",
                    }}
                  >
                    {projectDetails?.ProjectType}
                  </span>
                )}
              </div>
              <div className="head-actions justify-content-end">
                {createProject && (
                  <div className="flex ic gap6">

                    <button className="btn-og btn-og-secondary btn-og-sm"><Link
                      to="/Project/List"
                      style={{ display: "flex", justifyContent: "flex-start" }}
                      title="Back"
                    >
                      <i className="fa-solid fa-arrow-left"></i>
                    </Link></button>
                    <button
                      className="btn-og btn-og-secondary btn-og-sm"
                      onClick={() => editProject()}
                      title="Edit"
                    >
                      <i className="fa-solid fa-pen"></i>
                    </button>
                    {projectDetails?.ProjectStatusId != 106 && (
                      <button
                        className="btn-og btn-og-secondary btn-og-sm"
                        onClick={() => askArchive()}
                        title="Archive"
                      >
                        <i className="fa-solid fa-archive"></i>
                      </button>
                    )}
                    <button
                      className="btn-og theme-color btn-og-sm"
                      onClick={() => askDeleteConfirm()}
                      title="Delete"
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>

                    <select
                      className="fs"
                      style={{ width: "120px" }}
                      value={selectedStatus || projectDetails?.ProjectStatusId}
                      onChange={(e) => handleStatusChange(e.target.value)}
                    >
                      <option value="">All Status</option>
                      {projectStatus.map((Status) => (
                        <option key={Status.Id} value={Status.Id}>
                          {Status.Name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <button
                  className="btn btn-brand btn-sm"
                  onClick={() => setAddModalOpen(true)}
                >
                  <i className="fa-solid fa-plus"></i> New Task
                </button>

              </div>
            </div>
            <div className="bottom">
              <div style={{ flex: 1 }}>
                <h2
                  style={{
                    fontSize: "21px",
                    fontWeight: "800",
                    margin: "0 0 0px",
                    lineHeight: "1.3",
                    display: "flex",
                    alignItems: "center",
                    gap: "7px",
                    marginBottom: "6px"
                  }}
                >
                  {projectDetails?.Name}<div>
                    <input
                      type="checkbox"
                      id="toggle-switch-btn"
                      checked={projectDetails?.IsPublic === true}
                      readOnly
                    />

                    <div className="icon-circle">
                      {projectDetails?.IsPublic ? (
                        <i title="Public" className="fa-solid fa-lock-open"></i>
                      ) : (
                        <i title="Private" className="fa-solid fa-lock"></i>
                      )}

                    </div>
                  </div>
                </h2>

                {projectDetails?.Desc ? (
                  <div className="projectdetail-p">
                    {isLong && !isExpanded ? (
                      <>
                        <span className="htmlcontent"
                          dangerouslySetInnerHTML={{
                            __html: projectDetails.Desc.substring(0, CHAR_LIMIT) + "…",
                          }}
                        />
                        <button
                          className="btn btn-link btn-sm p-0 mb-3 read-more-btn"
                          onClick={() => setIsExpanded(true)}
                        >
                          Read more
                        </button>
                      </>
                    ) : (
                      <>
                        <span className="htmlcontent"
                          dangerouslySetInnerHTML={{ __html: projectDetails.Desc }}
                        />
                        {isLong && (
                          <button
                            className="btn btn-link btn-sm p-0 mb-3 read-more-btn"
                            onClick={() => setIsExpanded(false)}
                          >
                            Read less
                          </button>
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  <p>No description.</p>
                )}

                <div
                  className="flex gap14 text-muted"
                  style={{ fontSize: "12px", gap: "14px" }}
                >
                  <span>
                    <i
                      className="fa-regular fa-calendar"
                      style={{ marginRight: "3px" }}
                    ></i>
                    {fmtDate(projectDetails?.StartDate)} →{" "}
                    {fmtDate(projectDetails?.EndDate)}
                  </span>
                  <span>
                    <i
                      className="fa-solid fa-users"
                      style={{ marginRight: "3px" }}
                    ></i>
                    {projectDetails?.Members}{" "}
                    {projectDetails?.Members > 1 ? "members" : "member"}
                  </span>
                  <span onClick={() => {
                    document
                      .getElementById("task-list-section")
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className="fa-solid fa-list-check"
                      style={{ marginRight: "3px" }}
                    ></i>
                    {projectDetails?.TaskCount}{" "}
                    {projectDetails?.TaskCount > 1 ? "tasks" : "task"}
                  </span>
                </div>
              </div>
              {projectDetails?.ManagerName && (
                <div
                  className="img-flex-div">
                  {/* {avHtml(projectDetails?.ManagerName, 18)} */}
                  <LazyImage src={projectDetails?.ManagerImage} alt={projectDetails?.ManagerName} width="20px" />
                  <span>
                    {projectDetails?.ManagerName}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="page" style={{ borderTop: "1px solid #0000001c", paddingTop: "13px" }}>
          <div className="flex" style={{ flex: 1, overflow: "hidden" }}>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowY: "scroll",
                height: "calc(100vh - 13vh)",
              }}
            >
              {renderHeader()}
              {renderSummary()}

              {/* ROW: Client + Team + Files */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 2fr",
                  gap: "14px",
                  marginBottom: "14px",
                }}
              >
                {/* Client Card */}
                <div className="card">
                  <div className="ch" style={{ alignItems: "center", justifyContent: "space-between" }}>
                    <h5>Client</h5>
                    {renderClientSection()}
                  </div>

                  <div className="ch">
                    <h5>Team</h5>
                    <span
                      className="mla text-muted"
                      style={{ fontSize: "12px", cursor: "pointer" }}
                      onClick={() => {
                        setEditMemberDrawer(true);
                        fetchEmployeeIdData();
                      }}
                    >
                      {projectDetails?.ProjectMemberList?.length}{" "}
                      {projectDetails?.ProjectMemberList?.length > 1
                        ? "members"
                        : "member"}
                    </span>
                    {(createProject || userDetails?.EmpId == projectDetails?.ManagerId) && (
                      <button
                        className="btn btn-ghost btn-sm"
                        style={{ fontSize: "11px", marginLeft: "6px", cursor: "pointer" }}
                        onClick={() => {
                          setEditMemberDrawer(true);
                          fetchEmployeeIdData();
                        }}
                      >
                        <i className="fa-solid fa-pen"></i>
                      </button>
                    )}
                  </div>
                  <div className="cb">
                    <div className="renderteam">
                      {renderTeamSection()}
                    </div>
                  </div>
                </div>

                {/* Team Card */}
                {/* <div className="card">
              <div className="ch">
                <h5>Team</h5>
                <span className="mla text-muted" style={{ fontSize: '12px' }}>{proj.members.length}</span>
                <button className="btn btn-ghost btn-sm" style={{ fontSize: '11px', marginLeft: '6px' }} onClick={() => alert('Edit Team')}><i className="fa-solid fa-pen"></i> Edit</button>
              </div>
              <div className="cb" style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                {renderTeamSection()}
              </div>
            </div> */}

                {/* Files Card */}
                <div className="card">
                  <div className="ch">
                    <h5>Files</h5>
                    {createProject && (
                      <button
                        className="btn btn-outline btn-sm mla"
                        onClick={() => setUploadFile(true)}
                      >
                        <i className="fa-solid fa-upload"></i> Upload
                      </button>
                    )}
                  </div>
                  <div className="cb">
                    <div className="">{renderFilesSection()}</div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row gx-2 modules-segments">
                  <div className="col-lg-6 modules-main-div">
                    <div className="card mb14">
                      <div className="ch">
                        <h5>Modules</h5>

                        {(createProject || userDetails?.EmpId == projectDetails?.ManagerId) && (
                          <div className="mla flex gap6">
                            <button
                              className="btn btn-outline btn-sm"
                              onClick={() => setModulePopup(true)}
                            >
                              <i className="fa-solid fa-plus"></i>
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="cb" style={{ padding: "13px" }}>
                        {projectDetails?.ProjectModuleList?.length > 0 ? (
                          <>
                            {/* MODULES (Horizontal Chips) */}
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                flexWrap: "wrap",
                              }}
                            >
                              {projectDetails.ProjectModuleList.map(
                                (mod, i) => {
                                  const isActive = selectedModuleId === mod?.Id;

                                  return (
                                    <div
                                      key={mod?.Id || i}
                                      className={`mod-chip ${isActive ? "active" : ""}`}
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() =>
                                        setSelectedModuleId(mod?.Id)
                                      }
                                    >
                                      <span>{mod?.Name}</span>

                                      {createProject && (
                                        <button
                                          className="btn btn-ghost btn-icon btn-sm text-danger"
                                          onClick={(e) => {
                                            e.stopPropagation(); // prevent selecting module
                                            setAllDeletedModal(true);
                                            setDeletedId(mod?.Id);
                                            setDeletedLabel("module");
                                          }}
                                        >
                                          <i className="fa-solid fa-trash"></i>
                                        </button>
                                      )}
                                    </div>
                                  );
                                },
                              )}
                            </div>

                            {/* SUBMODULES (only for active module) */}
                            <div>
                              {projectDetails.ProjectModuleList.map((mod) => {
                                const isActive = selectedModuleId === mod?.Id;

                                if (!isActive) return null;

                                return (
                                  <div
                                    key={mod?.Id}
                                    style={{
                                      marginTop: "10px",
                                      paddingTop: 10,
                                      borderTop: "1px solid var(--border)",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: "11.5px",
                                        color: "var(--muted)",
                                        textTransform: "uppercase",
                                        fontWeight: "700",
                                        marginBottom: "6px",
                                      }}
                                    >
                                      {mod?.Name?.toUpperCase()} — SUB MODULES
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      {mod?.ProjectSubModuleList?.map((sm) => (
                                        <span
                                          key={sm?.Id}
                                          className="sub-mod-chip"
                                        >
                                          {sm?.Name}

                                          {createProject && (
                                            <button
                                              className="btn btn-ghost btn-icon btn-sm text-danger"
                                              onClick={() => {
                                                setAllDeletedModal(true);
                                                setDeletedId(sm?.Id);
                                                setSubModuleId(sm?.ModuleId);
                                                setDeletedLabel("sub-module");
                                              }}
                                            >
                                              <i className="fa-solid fa-trash"></i>
                                            </button>

                                          )}
                                        </span>
                                      ))}

                                      {/* Add Submodule */}
                                      {(createProject || userDetails?.EmpId == projectDetails?.ManagerId) && (
                                        <button
                                          className="btn btn-ghost btn-sm btn-link"
                                          style={{
                                            fontSize: "11px",
                                            color: "var(--brand)",
                                          }}
                                          onClick={() => setSubModulePopup(true)}
                                        >
                                          + Sub Module
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        ) : (
                          <div
                            style={{
                              textAlign: "center",
                              padding: "30px",
                              color: "var(--muted)",
                              fontSize: "12.5px",
                            }}
                          >
                            No modules defined yet.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 modules-main-div">
                    {/* Segments */}
                    <div className="card mb14">
                      <div className="ch">
                        <h5>Segments</h5>
                        <div className="mla flex gap6">
                          {(createProject || userDetails?.EmpId == projectDetails?.ManagerId) && (
                            <button
                              className="btn btn-outline btn-sm"
                              onClick={() => setSegmentPopup(true)}
                            >
                              <i className="fa-solid fa-plus"></i>
                            </button>
                          )}
                        </div>
                      </div>
                      <div
                        className="cb"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        {projectDetails?.ProjectSegmentList?.length > 0 ? (
                          projectDetails?.ProjectSegmentList?.map((seg, i) => (
                            <span
                              key={i}
                              className={`badge ${segBadge(seg)}`}
                              style={{
                                fontSize: "12px",
                                padding: "4px 12px",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              {seg?.Name}

                              {createProject && (
                                <button
                                  className="btn btn-ghost btn-icon btn-sm text-danger"
                                  onClick={() => {
                                    setAllDeletedModal(true);
                                    setDeletedId(seg?.Id);
                                    setDeletedLabel("segment");
                                  }}
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </button>
                              )}
                            </span>
                          ))
                        ) : (
                          <span>No segments</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Tasks Section */}
              <div className="card">
                <div className="ch">
                  <h5>Tasks</h5>
                  <div className="flex ic gap6 mla">
                    <div className="sw">
                      <i className="fa-solid fa-magnifying-glass"></i>
                      <input
                        className="si"
                        placeholder="Search…"
                        value={filterQuery}
                        onChange={(e) => setFilterQuery(e.target.value)}
                      />
                    </div>

                    <MultiSelect
                      value={filterStatus}
                      onChange={(e) => setFilterStatus(e.value)}
                      options={taskStatusType}
                      optionLabel="Name"
                      placeholder="Select Status"
                      optionValue="Id"
                      className="w-full md:w-20rem"
                    />

                    <MultiSelect
                      value={filterModule}
                      onChange={(e) => setFilterModule(e.value)}
                      options={masterModuleList}
                      optionLabel="Name"
                      placeholder="Select Module"
                      optionValue="Id"
                      className="w-full md:w-20rem"
                    />

                    <MultiSelect
                      value={filterPriority}
                      onChange={(e) => setFilterPriority(e.value)}
                      options={taskPriorityList}
                      optionLabel="Name"
                      placeholder="Select Priority"
                      optionValue="Id"
                      className="w-full md:w-20rem"
                    />

                    {/* <div className="vtog">
                  <button
                    className={`vbtn ${curView === "list" ? "active" : ""}`}
                    onClick={() => setCurView("list")}
                  >
                    <i className="fa-solid fa-list"></i> List
                  </button>
                  <button
                    className={`vbtn ${curView === "board" ? "active" : ""}`}
                    onClick={() => setCurView("board")}
                  >
                    <i className="fa-solid fa-table-columns"></i> Board
                  </button>
                </div> */}

                    {/* <button
                    className="btn btn-brand btn-sm"
                    onClick={() => alert("Add Task")}
                  >
                    <i className="fa-solid fa-plus"></i> Add Task
                  </button> */}
                    <Link
                      onClick={() => {
                        window.open(
                          `/Project/Tasks/${projId}`,
                          "_blank"
                        );
                      }}
                      className="btn btn-outline btn-sm"
                    >
                      All Tasks <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>

                {/* List View */}
                {/* {curView === "list" && ( */}
                <div id="pdList">
                  <table className="dtbl">
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>No.</th>
                        <th>Segment</th>
                        <th>Priority</th>
                        <th>Assigned</th>
                        <th>Due | Est.</th>
                        {/* <th>Actions</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {projectTaskList?.length === 0 ? (
                        <tr>
                          <td
                            colSpan="12"
                            style={{
                              padding: "36px",
                              textAlign: "center",
                              color: "var(--muted)",
                            }}
                          >
                            No tasks match filters
                          </td>
                        </tr>
                      ) : (
                        projectTaskList?.map((t) => (
                          <tr key={t?.Id} onClick={() => NavigateTaskDetail(t)}>

                            <td style={{ maxWidth: "220px" }}>
                              <p className="mb-0" style={{ fontWeight: 600 }}>
                                {t?.TaskTitle || "N/A"}
                              </p>
                              <p className="module-status">
                                <span title="Module"> {t?.ModuleName || "N/A"} - </span>
                                <span title="Sub module">  {t?.SubModuleName || "N/A"}</span>
                                <span>| </span>
                                <span title="Type">  {t?.TaskTypeName || "N/A"}</span>
                                <span>| </span>
                                <span title="Segment">  {t?.SegmentName || "N/A"}</span>
                              </p>
                            </td> <td>
                              <code
                                style={{
                                  fontSize: "10.5px",
                                  fontWeight: "700",
                                  color: "var(--brand)",
                                }}
                              >
                                {t?.TaskNumber || "N/A"}
                              </code>
                            </td>
                            <td>
                              <span
                                className={`badge ${pBadge(t?.PriorityName)}`}
                              >
                                {t?.PriorityName || "N/A"}
                              </span>
                            </td>
                            <td>
                              <span
                                className={`badge ${sBadge(t?.StatusName)}`}
                              >
                                {t?.StatusName || "N/A"}
                              </span>
                            </td>
                            <td>
                              <div>
                                {t?.AssignToUserGUID ? (
                                  <Link
                                    to={`/Profile/${t.AssignToUserGUID}`}
                                    className="member-chip"
                                  >
                                    <LazyImage
                                      alt={t?.AssignToName}
                                      src={t?.AssignToProfileImage}
                                      width="20px"
                                    />
                                    {t?.AssignToName || "N/A"}
                                  </Link>
                                ) : (
                                  <div className="member-chip" style={{ opacity: 0.6, cursor: "default" }}>
                                    <LazyImage
                                      alt={t?.AssignToName}
                                      src={t?.AssignToProfileImage}
                                      width="20px"
                                    />
                                    {t?.AssignToName || "N/A"}
                                  </div>
                                )}
                              </div>
                            </td>
                            <td
                              style={{
                                fontSize: "11.5px",
                                color: "var(--muted)",
                              }}
                            >
                              {fmtDate(t?.DueDate)}<br /> {t?.EstimatedHours}h
                            </td>
                            {/* <td onClick={(e) => e.stopPropagation()}>
                            <div className="flex gap3">
                              <button
                                className="btn btn-ghost btn-icon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  alert(`Edit ${t.taskNo}`);
                                }}
                              >
                                <i className="fa-solid fa-pen"></i>
                              </button>
                              <button
                                className="btn btn-ghost btn-icon"
                                style={{ color: "var(--red)" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  alert(`Delete ${t.taskNo}`);
                                }}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>
                            </div>
                          </td> */}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
                {/* )} */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals can be added as separate components if needed */}
      {modulePopup && (
        <div
          className="modal show"
          id="add-module"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-0">
              <div className="modal-header">
                <h5 className="modal-title">Add Module</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setModulePopup(false);
                    setModuleName("");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                <div className="">
                  <label>Module Name</label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => {
                      setModuleName(e.target.value);
                    }}
                  ></input>
                </div>
              </div>

              <div className="col-md-12">
                <div className="btns-grp">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    onClick={() => {
                      setModulePopup(false);
                      setModuleName("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="savebtn-click btn-purple rounded"
                    onClick={() => AddModule()}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {subModulePopup && (
        <div
          className="modal show "
          id="add-sub-module"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-0">
              <div className="modal-header">
                <h5 className="modal-title">Add Sub Module</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setSubModulePopup(false);
                    setSubModuleName("");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                <div className="">
                  <label>Sub Module Name</label>
                  <input
                    className="form-control"
                    type="text"
                    onChange={(e) => setSubModuleName(e.target.value)}
                  ></input>
                </div>
              </div>

              <div className="col-md-12">
                <div className="btns-grp">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    onClick={() => {
                      setSubModulePopup(false);
                      setSubModuleName("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="savebtn-click btn-purple rounded"
                    onClick={() => AddSubModule()}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {segmentPopup && (
        <div
          className="modal show "
          id="add-segment"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-0">
              <div className="modal-header">
                <h5 className="modal-title">Add Segment</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setSegmentPopup(false);
                    setSegmentName("");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                <div className="">
                  <label>Segment Name</label>
                  <input
                    type="text"
                    className="form-control"
                    onChange={(e) => setSegmentName(e.target.value)}
                  ></input>

                  {segmentError && (
                    <div className="invalid-Feedback">
                      <span>Segment is required.</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="btns-grp">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setSegmentPopup(false);
                      setSegmentName("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="savebtn-click btn-purple rounded"
                    onClick={() => AddSegment()}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isArchConfirmOpen && (
        <div
          className="modal show"
          id="delete-project-confirm"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <p>
                  Archive this project? It will be hidden from active views but
                  tasks will be preserved.
                </p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => setIsArchConfirmOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  onClick={() => archiveProject()}
                >
                  Archive
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isEditModalOpen && (
        <AddProject
          isOpen={isEditModalOpen}
          onClose={(e) => onClosePopup(e)}
          editProjectDetails={editProjectDetails}
        ></AddProject>
      )}

      {isDeletedModal && (
        <div
          className="modal show"
          id="delete-project-confirm"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to delete this project?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => setDeletedModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  onClick={() => deleteProject()}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {uploadFile && (
        <div
          className="modal show "
          id="add-file"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-0">
              <div className="modal-header border-0">
                {/* <h5 className="modal-title">Upload File</h5> */}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setDocPathUrl("");
                    setUploadFile(false);
                  }}
                ></button>
              </div>

              <div className="modal-body">
                <div className="">
                  <label>Upload File</label>
                  <input
                    type="file"
                    id="file-upload"
                    className="form-control"
                    onChange={handleFileChangeDoc}
                    accept=".doc,.docx,.pdf,.xls,.xlsx,.csv,.zip,.rar,.ppt,.pptx,.jpg,.jpeg,.png,"
                  />{" "}
                  {segmentError && (
                    <div className="invalid-Feedback">
                      <span>Segment is required.</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="btns-grp">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setDocPathUrl("");
                      setUploadFile(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="savebtn-click btn-purple rounded"
                    onClick={() => projectDocAdd()}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isAllDeletedModal && (
        <div
          className="modal show"
          id="delete-all-confirm"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to delete this {deletedLabel}?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => {
                    setAllDeletedModal(false);
                    setDeletedLabel("");
                    setDeletedId(0);
                    setSubModuleId(0);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  onClick={() => deletedAll()}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {editMemberDrawer && (
        <div className="team-drawer open" id="teamDrawer">
          <div className="td-head">
            <i className="fa-solid fa-users text-brand"></i>
            <h5>Team Members</h5>
            <button
              className="btn btn-ghost btn-icon"
              onClick={() => setEditMemberDrawer(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div className="td-body">
            {(createProject || userDetails?.EmpId == projectDetails?.ManagerId) && (
              <div className="project-member-popup">
                <label className="fl">Add Member</label>
                <div className="flex gap8">
                  {/* <select className="fs" id="teamAddSelect" >
               <option value="">Select member to add…</option>
               {}
               <option>Vikram Singh</option>
               <option>Deepa Rao</option>
               <option>Sanjay Kumar</option>
            </select> */}

                  <select
                    className="fs"
                    value={selectedMember}
                    onChange={(e) => setSelectedMember(e.target.value)}
                  >
                    <option value="">Select</option>
                    {employeeList?.map((e) => (
                      <option key={e?.Id} value={e?.Id}>
                        {e?.FullName}
                      </option>
                    ))}
                  </select>
                  <button
                    className="btn btn-brand btn-sm"
                    onClick={() => AddTeamMember()}
                  >
                    <i className="fa-solid fa-plus"></i> Add
                  </button>
                </div>
              </div>
            )}

            <div className="tdmembercount" id="tdMemberCount">
              {projectDetails?.ProjectMemberList?.length}{" "}
              {projectDetails?.ProjectMemberList?.length > 1
                ? "members"
                : "member"}
            </div>
            <div id="tdMemberList">
              {projectDetails?.ProjectMemberList.map((pm) => (
                <div className="td-member-row" style={{ cursor: "pointer" }} key={pm?.Id} onClick={() => history.push(`/Profile/${pm?.EmployeeGUID}`)}>
                  <div className="td-member-title" title={pm?.EmployeeName} >
                    <LazyImage alt={pm?.EmployeeName} src={pm?.ProfileImage} style={{ width: "20px" }} />
                    {/* {avHtml(pm?.EmployeeName, 22)} */}
                  </div>
                  <div className="td-member-area">
                    <div className="td-member-name">{pm?.EmployeeName}</div>
                    <div className="td-member-des">Team Member</div>
                  </div>

                  {(createProject || userDetails?.EmpId == projectDetails?.ManagerId) && (
                    <button
                      className="btn btn-ghost btn-icon"
                      title="Remove"
                      onClick={(e) => {
                        e.stopPropagation();
                        setAllDeletedModal(true);
                        setDeletedLabel("member");
                        setDeletedId(pm?.EmpId);
                      }}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  )}

                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <AddTask
          isOpen={isModalOpen}
          onClose={(e) => {
            setAddModalOpen(false);
            if (e === 'success') {
              getProjectsTaskList(projectDetails?.Id);
            }
          }}
          editTaskDetails={{}}
          subTaskProjectId={projectDetails?.Id}
          parentId={0}
          taskCopy={false}
          detailPage={true}
        />
      )}

      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default TaskManagementProjectDetail;
